import { ColDef, ICellRendererParams } from 'ag-grid-community'
import { format } from 'date-fns'

import EditIcon from '@/assets/edit.svg?react'
import { AssetNameCell, LinkButton } from '@/components/core-v2'
import { Currency, formatCurrencyFull } from '@/utilities/currency'
import { formatToDateDisplay } from '@/utilities/date'

import classes from './index.module.scss'

export const PriceCell = ({ context, data }: ICellRendererParams<any>) => {
  const getFormattedPrice = (value: number) => formatCurrencyFull(value, data.currency as Currency)

  return (
    <LinkButton onClick={() => context.onShowPriceOverride(data)}>
      {getFormattedPrice(data.currentPrice?.price)}
      <EditIcon className={classes.icon} />
    </LinkButton>
  )
}

export const COLUMN_DEFS: ColDef[] = [
  { headerName: 'Name', field: 'assetName', minWidth: 200, flex: 2.5, cellRenderer: AssetNameCell },
  {
    headerName: 'ISIN',
    field: 'isinCode',
    minWidth: 180,
    flex: 2
  },
  {
    headerName: 'Latest price',
    field: 'currentPrice.price',
    minWidth: 180,
    flex: 2,
    cellRenderer: PriceCell
  },
  {
    headerName: 'Value date',
    field: 'currentPrice.valueDate',
    minWidth: 220,
    flex: 1,
    type: 'rightAligned',
    valueFormatter: ({ value }) => (value ? formatToDateDisplay(value) : '-')
  },
  {
    headerName: 'Received time',
    field: 'currentPrice.receivedDateTime',
    minWidth: 220,
    flex: 2,
    type: 'rightAligned',
    valueFormatter: ({ value }) => (value ? format(new Date(value), 'dd/MM/yyyy HH:mm') : '-')
  }
]

export const DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: true,
  unSortIcon: true
}
